import { render, staticRenderFns } from "./userLoginEdit.vue?vue&type=template&id=0bfb20e6&scoped=true"
import script from "./userLoginEdit.vue?vue&type=script&lang=js"
export * from "./userLoginEdit.vue?vue&type=script&lang=js"
import style0 from "./userLoginEdit.vue?vue&type=style&index=0&id=0bfb20e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb20e6",
  null
  
)

export default component.exports